import * as coreActions from './core.actions';

export default coreActions;
